<template>
    <div>
    <template>
        <v-card
            class="mx-auto contact-card"
        >
            <div v-html="cms_page.html"></div>
              <v-btn color="primary" dark v-on:click='accept' block data-cypress-value="acceptTermsButton">
                {{ translations.consentpage.acceptclose }}
            </v-btn>
        </v-card>
        </template>
    </div>
</template>
<style lang="scss" scoped>
    .contact-card {
        height: 100%;
        border-radius: 0px;
        margin: 0px;
        padding: 30px;
    }
    .v-btn {
        background-color: #42113C;
    }

</style>
<script>
    import hubbdata from "@/hubbdata";
    import router from '../router/index.js'


    export default {
        data: () => ({

        }),

        methods: {
            accept() {
                localStorage.setItem('terms_accepted', "true")
                router.push("/home")

            }
        },
        computed: {
            translations() {
                return hubbdata.getters.translations;
            },
            cms_page() {
              return hubbdata.getters.getCmsPageByPath('terms-and-conditions')
            },
        },

  }
</script>
